import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export const BuyNowButton = ({ testId, className = "" }) => <p className={`text-sm leading-relaxed ${className}`} data-testid={`${testId}-unavailable`}>Online purchasing is not yet available. Please request a trade quote.</p>;

export const QuoteOnlyNotice = ({ testId = 'quote-only-notice' }) => <div className="rounded-md border border-ei-mist bg-white p-6 sm:p-8" data-testid={testId}>
  <h2 className="text-lg font-semibold text-ei-navy">Online purchasing is not yet available</h2>
  <p className="mt-3 text-sm leading-relaxed text-ei-graphite">We’re accepting trade quote requests. Our team will confirm equipment, pricing, stock and delivery with you. No online payment is being collected.</p>
  <Link to="/request-a-quote" className="mt-5 inline-flex min-h-[44px] items-center rounded-sm bg-ei-navy px-5 py-3 text-sm font-semibold text-white" data-testid={`${testId}-request`}>Request a trade quote</Link>
</div>;

export const PurchasingUnavailable = () => <>
  <Seo title="Request a trade quote — EI Battery Solutions" description="Online purchasing is not yet available. Request a checked trade quote from EI Battery Solutions."/>
  <section className="mx-auto max-w-4xl px-4 py-12 sm:px-6 sm:py-16" data-testid="quote-only-checkout"><QuoteOnlyNotice testId="checkout-unavailable"/></section>
</>;
